export default __webpack_public_path__ + "static/media/28.79605859.jpg";